<mat-card class="proposal-card">

  <mat-card-actions class="actions">
    <a routerLink="/projectes">
      {{ 'dashboardPanells.treballsIniciatsPendentsContracte' | translate }}
    </a>

    <span
      class="link"
      (click)="viewAllProjects()">
      {{ 'dashboardManifestacions.veureMes' | translate }}
    </span>
  </mat-card-actions>

  <mat-card-content *ngIf="activeProjects?.length; else empty">

    <mat-list-item
      class="proposal-item"
      *ngFor="let project of activeProjects"
      (click)="navigateToProject(project)">
      <p mat-line style="font-weight:bold">
        {{(project.titol ? project.titol : ('dashboardTreballsIniciats.senseTitol' | translate))}}
      </p>
      <p mat-line>
        {{ 'dashboardTreballsIniciats.dataAprovacio' | translate }} {{project.data_aprovacio}}
        <span *ngIf="project.personal_id" style="margin-left:40px">{{ 'dashboardTreballsIniciats.coordinacio' | translate }} {{project.name}}</span>
      </p>
      <p mat-line>
        <span style="margin-left:0px">{{ 'dashboardTreballsIniciats.pressupostContractat' | translate }} {{project.pressupost_contractat_loc | number:'1.2-2'}} ({{project.moneda_press_proj}})</span>
        <span style="margin-left:10px">{{ 'dashboardTreballsIniciats.pressupostPropi' | translate }} {{project.import_propi | number:'1.2-2'}} ({{project.moneda_import_propi}})</span>
      </p>
      <h3 mat-line style="padding-bottom: 15px">
       <span style="margin-left:0px;float: left;clear: none;padding-right: 5px">

        <span *ngIf="project.import_propi == null" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="{{ 'dashboardTreballsIniciats.noImportPropi' | translate }}">payments</mat-icon></span>
        <span *ngIf="project.import_propi != null" style="width:15px;float:left"><mat-icon style="color: green;font-size:14px" title="{{ 'dashboardTreballsIniciats.siImportPropi' | translate }}">payments</mat-icon></span>


        <span *ngIf="project.facturacio == null && project.facturacio != 0" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="{{ 'dashboardTreballsIniciats.noFacturacio' | translate }}">alarm_off</mat-icon></span>
        <span *ngIf="project.facturacio != null && project.facturacio > 0.01" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="{{ 'dashboardTreballsIniciats.errorFacturacio' | translate }}">alarm_off</mat-icon></span>
        <span *ngIf="project.facturacio != null && project.facturacio <= 0.01" style="width:15px;float:left"><mat-icon style="color: green;font-size:14px" title="{{ 'dashboardTreballsIniciats.okFacturacio' | translate }}">alarm_off</mat-icon></span>

        <span *ngIf="(project.p_cobraments != null && project.facturacio != null) || (project.p_cobraments == null && project.facturacio == null)" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="{{ 'dashboardTreballsIniciats.cobratNoTancat' | translate }}">gps_off</mat-icon></span>
        <span *ngIf="project.p_cobraments == null && project.facturacio != null" style="width:15px;float:left"><mat-icon style="color: green;font-size:14px" title="{{ 'dashboardTreballsIniciats.pendentCobrar' | translate }}">gps_off</mat-icon></span>

        <span *ngIf="project.facturacio == null || project.dates" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="{{ 'dashboardTreballsIniciats.errorDatesFacturacio' | translate }}">date_range</mat-icon></span>
        <span *ngIf="project.facturacio != null && !project.dates" style="width:15px;float:left"><mat-icon style="color: green;font-size:14px" title="{{ 'dashboardTreballsIniciats.okDatesFacturacio' | translate }}">date_range</mat-icon></span>
        <span *ngIf="project.facturacio == null || project.dates_c" style="width:15px;float:left"><mat-icon style="color: red;font-size:14px" title="{{ 'dashboardTreballsIniciats.errorDatesCobrament' | translate }}">event</mat-icon></span>
        <span *ngIf="project.facturacio != null && !project.dates_c" style="width:15px;float:left"><mat-icon style="color:green;font-size:14px" title="{{ 'dashboardTreballsIniciats.okDatesCobrament' | translate }}">event</mat-icon></span>
        <span *ngIf="!project.n_fites || n_fites == 0" style="width:15px;float:left"><mat-icon style="color:red;font-size:14px" title="{{ 'dashboardTreballsIniciats.noFites' | translate }}">pin_drop</mat-icon></span>
        <span *ngIf="project.n_fites && n_fites !== 0" style="width:15px;float:left"><mat-icon style="color:green;font-size:14px" title="{{ 'dashboardTreballsIniciats.siFites' | translate }}">pin_drop</mat-icon></span>
       </span>
       <span *ngIf="project.ambit_proposta=='Europa'" style='color:#0000FF;font-size:1em'>{{project.clau}}</span>
       <span *ngIf="project.ambit_proposta=='Internacional'" style='color:#008800;font-size:1em'>{{project.clau}}</span>
       <span *ngIf="project.ambit_proposta=='Espanya'" style='color:#800000;font-size:1em'>{{project.clau}}</span>
       <span *ngIf="project.ambit_proposta=='Catalunya'" style='color:rgb(100,100,100);font-size:1em'>{{project.clau}}</span>
      </h3>

      <mat-divider></mat-divider>

    </mat-list-item>

  </mat-card-content>

  <ng-template #empty>
    <mat-card-content>
      <p>{{ 'dashboardTreballsIniciats.senseProjecte' | translate }}</p>
    </mat-card-content>
  </ng-template>

</mat-card>

<mcrit-gestio-list-resume
  class="resume"
  [dades]="resumeData"
  [titol]="'dashboardManifestacions.titolPropostesAmbit' | translate">
</mcrit-gestio-list-resume>
